import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { StoryWeaver } from './StoryWeaver';
import { LifeCoach } from './LifeCoach';

export function UserGenBlox() {
  const { botType } = useParams();

  // Map bot types to components
  const componentMap = {
    'content-synthesizer': StoryWeaver,
    'life-coach': LifeCoach
  };

  // Get the component for the current bot type
  const Component = componentMap[botType];

  // If no matching component is found, redirect to dashboard
  if (!Component) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Component />;
}

export default UserGenBlox; 